import React from 'react'
import { Table } from '../../../../../../../components/Table'
import { TableBody } from '../../../../../../../components/Table/TableBody'
import { TableHead } from '../../../../../../../components/Table/TableHead'
import { LoaderForTable } from '../../../../../../../components/Loader'
import { IProviderBase } from '../../core/types'
import ProviderItemRow from './ProviderItemRow'

interface Props {
  providers: IProviderBase[]
  isLoading: boolean
  detailsLoadingMap: Record<number, boolean>
  onOpenSettings: (provider: IProviderBase) => void
  onToggle: (providerId: number) => void
}

export default ({ providers, isLoading, detailsLoadingMap, onOpenSettings, onToggle }: Props) => {
  return (
    <div className='card'>
      <div className='card-body py-3'>
        <Table>
          <TableHead>
            <tr>
              <th className='min-w-150px'>Название</th>
              <th className='min-w-100px'>Включен</th>
              <th className='min-w-120px'>Внешний шлюз</th>
              <th className='min-w-150px'>Последняя транзакция</th>
              <th className='min-w-100px'>Пополнений</th>
              <th className='min-w-100px'>Выплат</th>
              <th className='min-w-100px'>Мерчанты</th>
              <th className='min-w-100px'>Связок</th>
              <th className='min-w-150px'>Создан</th>
              <th className='min-w-150px'>Обновлен</th>
              <th className='min-w-60px text-end'></th>
            </tr>
          </TableHead>
          <TableBody>
            {!isLoading && providers.length > 0 ? (
              providers.map((provider) => (
                <ProviderItemRow
                  key={provider.id}
                  provider={provider}
                  isDetailsLoading={!!detailsLoadingMap[provider.id]}
                  onOpenSettings={onOpenSettings}
                  onToggle={onToggle}
                />
              ))
            ) : (
              <LoaderForTable isLoading={isLoading} colSpan={11} />
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  )
}
